import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Shield, Globe, Monitor } from 'lucide-react';
const Login = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<'credentials' | 'otp'>('credentials');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [visitorData, setVisitorData] = useState({
    ip: '103.127.96.45',
    location: 'Jakarta, Indonesia',
    device: 'Chrome on Windows',
    timestamp: new Date().toLocaleString('id-ID')
  });
  useEffect(() => {
    const ua = navigator.userAgent;
    let browserName = 'Unknown';
    let osName = 'Unknown';
    if (ua.indexOf('Chrome') > -1) browserName = 'Chrome';else if (ua.indexOf('Firefox') > -1) browserName = 'Firefox';else if (ua.indexOf('Safari') > -1) browserName = 'Safari';else if (ua.indexOf('Edge') > -1) browserName = 'Edge';
    if (ua.indexOf('Windows') > -1) osName = 'Windows';else if (ua.indexOf('Mac') > -1) osName = 'MacOS';else if (ua.indexOf('Linux') > -1) osName = 'Linux';else if (ua.indexOf('Android') > -1) osName = 'Android';else if (ua.indexOf('iOS') > -1) osName = 'iOS';
    setVisitorData(prev => ({
      ...prev,
      device: `${browserName} on ${osName}`
    }));
  }, []);
  const handleCredentialsSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('Username dan password harus diisi');
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStep('otp');
    }, 1000);
  };
  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleOtpSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const otpCode = otp.join('');
    if (otpCode.length !== 6) {
      setError('Kode OTP harus 6 digit');
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      localStorage.setItem('auth_token', 'authenticated');
      navigate('/');
    }, 1000);
  };
  return <div className="min-h-screen w-full bg-gradient-to-br from-[#0A0E17] via-[#0F1419] to-[#0A0E17] flex items-center justify-center p-4" data-id="element-539">
      <div className="w-full max-w-lg" data-id="element-540">
        {/* Logo and Title */}
        <div className="text-center mb-8" data-id="element-541">
          <div className="flex justify-center mb-4" data-id="element-542">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9NrYJzdqEfnhGEe7xtwXX4/Logo_BIN_NEW.png" alt="BIN Logo" className="w-32 h-32" data-id="element-543" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-544">NEXUS BIN</h1>
          <p className="text-gray-400" data-id="element-545">Executive Intelligence Console</p>
        </div>
        {/* Login Form */}
        <div className="bg-[#111827] border border-gray-800 rounded-lg p-8 mb-6" data-id="element-546">
          {step === 'credentials' ? <form onSubmit={handleCredentialsSubmit} data-id="element-547">
              <div className="mb-6" data-id="element-548">
                <div className="flex items-center px-2 py-1 bg-red-900/30 rounded text-xs text-red-400 border border-red-800/50 mb-4" data-id="element-549">
                  <Lock className="h-3 w-3 mr-1" data-id="element-550" />
                  <span data-id="element-551">SECURE ACCESS REQUIRED</span>
                </div>
                <h2 className="text-xl font-semibold text-white mb-2" data-id="element-552">Login</h2>
                <p className="text-sm text-gray-400" data-id="element-553">
                  Masukkan kredensial Anda untuk mengakses sistem
                </p>
              </div>
              {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-800/50 rounded text-sm text-red-400" data-id="element-554">
                  {error}
                </div>}
              <div className="space-y-4 mb-6" data-id="element-555">
                <div data-id="element-556">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-557">
                    Username
                  </label>
                  <div className="relative" data-id="element-558">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-559" />
                    <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full pl-10 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="Masukkan username" data-id="element-560" />
                  </div>
                </div>
                <div data-id="element-561">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-562">
                    Password
                  </label>
                  <div className="relative" data-id="element-563">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-564" />
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="Masukkan password" data-id="element-565" />
                  </div>
                </div>
              </div>
              <button type="submit" disabled={loading} className="w-full bg-cyan-600 hover:bg-cyan-700 disabled:bg-gray-700 text-white py-3 rounded-lg font-medium transition-colors" data-id="element-566">
                {loading ? 'Memverifikasi...' : 'Lanjutkan'}
              </button>
            </form> : <form onSubmit={handleOtpSubmit} data-id="element-567">
              <div className="mb-6" data-id="element-568">
                <div className="flex items-center px-2 py-1 bg-cyan-900/30 rounded text-xs text-cyan-400 border border-cyan-800/50 mb-4" data-id="element-569">
                  <Shield className="h-3 w-3 mr-1" data-id="element-570" />
                  <span data-id="element-571">TWO-FACTOR AUTHENTICATION</span>
                </div>
                <h2 className="text-xl font-semibold text-white mb-2" data-id="element-572">
                  Verifikasi OTP
                </h2>
                <p className="text-sm text-gray-400" data-id="element-573">
                  Kode OTP telah dikirim ke perangkat Anda. Masukkan 6 digit
                  kode untuk melanjutkan.
                </p>
              </div>
              {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-800/50 rounded text-sm text-red-400" data-id="element-574">
                  {error}
                </div>}
              <div className="flex justify-center space-x-2 mb-6" data-id="element-575">
                {otp.map((digit, index) => <input key={index} id={`otp-${index}`} type="text" maxLength={1} value={digit} onChange={e => handleOtpChange(index, e.target.value)} className="w-12 h-12 text-center text-xl font-bold bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-cyan-500" data-id="element-576" />)}
              </div>
              <button type="submit" disabled={loading} className="w-full bg-cyan-600 hover:bg-cyan-700 disabled:bg-gray-700 text-white py-3 rounded-lg font-medium transition-colors mb-3" data-id="element-577">
                {loading ? 'Memverifikasi...' : 'Verifikasi & Login'}
              </button>
              <button type="button" onClick={() => setStep('credentials')} className="w-full text-gray-400 hover:text-white text-sm py-2" data-id="element-578">
                Kembali ke login
              </button>
            </form>}
        </div>
        {/* Connection Info Section - Now Below Form */}
        <div className="w-full bg-[#111827] border border-gray-800 rounded-lg p-6 mb-6" data-id="element-579">
          <div className="flex items-center justify-between mb-4" data-id="element-580">
            <h3 className="text-lg font-semibold text-white" data-id="element-581">
              Connection Info
            </h3>
            <div className="flex items-center space-x-1" data-id="element-582">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-583"></div>
              <span className="text-xs text-green-400" data-id="element-584">Live</span>
            </div>
          </div>
          {/* 2x2 Grid Layout */}
          <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-585">
            {/* Top Left - IP Address */}
            <div className="p-3 bg-gray-800/50 rounded-lg" data-id="element-586">
              <div className="flex items-start space-x-2" data-id="element-587">
                <Globe className="h-5 w-5 text-cyan-400 flex-shrink-0" data-id="element-588" />
                <div data-id="element-589">
                  <p className="text-xs text-gray-400" data-id="element-590">IP Address</p>
                  <p className="text-sm text-white font-medium" data-id="element-591">
                    {visitorData.ip}
                  </p>
                </div>
              </div>
            </div>
            {/* Top Right - Location */}
            <div className="p-3 bg-gray-800/50 rounded-lg" data-id="element-592">
              <div className="flex items-start space-x-2" data-id="element-593">
                <Globe className="h-5 w-5 text-blue-400 flex-shrink-0" data-id="element-594" />
                <div data-id="element-595">
                  <p className="text-xs text-gray-400" data-id="element-596">Location</p>
                  <p className="text-sm text-white font-medium" data-id="element-597">
                    {visitorData.location}
                  </p>
                </div>
              </div>
            </div>
            {/* Bottom Left - Device */}
            <div className="p-3 bg-gray-800/50 rounded-lg" data-id="element-598">
              <div className="flex items-start space-x-2" data-id="element-599">
                <Monitor className="h-5 w-5 text-purple-400 flex-shrink-0" data-id="element-600" />
                <div data-id="element-601">
                  <p className="text-xs text-gray-400" data-id="element-602">Device</p>
                  <p className="text-sm text-white font-medium" data-id="element-603">
                    {visitorData.device}
                  </p>
                </div>
              </div>
            </div>
            {/* Bottom Right - Connected at */}
            <div className="p-3 bg-gradient-to-r from-cyan-900/20 to-blue-900/20 border border-cyan-800/30 rounded-lg" data-id="element-604">
              <div className="flex items-start space-x-2" data-id="element-605">
                <Shield className="h-5 w-5 text-cyan-400 flex-shrink-0" data-id="element-606" />
                <div data-id="element-607">
                  <p className="text-xs text-cyan-400" data-id="element-608">Connected at</p>
                  <p className="text-sm text-white font-medium" data-id="element-609">
                    {visitorData.timestamp}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Security Notice at Bottom */}
          <div className="p-3 bg-yellow-900/20 border border-yellow-800/30 rounded-lg" data-id="element-610">
            <div className="flex items-start space-x-2" data-id="element-611">
              <Shield className="h-4 w-4 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-612" />
              <p className="text-xs text-gray-400" data-id="element-613">
                Your connection is monitored for security purposes
              </p>
            </div>
          </div>
        </div>
        <p className="text-center text-xs text-gray-500" data-id="element-614">
          Sistem Keamanan Tingkat Tinggi - Badan Intelijen Negara
        </p>
      </div>
    </div>;
};
export default Login;